import { TaskAssigneesController } from './task-assignees.controller'

function taskAssignees () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      assignees: '<'
    },
    templateUrl: '/workflow/directives/task-assignees/task-assignees-directive.html?$$REVISION$$',
    controller: TaskAssigneesController
  }
}

export { taskAssignees }
